<template>
  <section id="parentSection" class="my-5 breakdown-section scroll-snap-section">
    <div>
      <h2>Parental DNA</h2>
      <div id="motherline">
        <div v-if="sharingStore.motherlineResult">
          <h5 class="pt-3 mb-3">{{ sharingStore.name }}'s Motherline</h5>
          <div class="card card-maternal border-red mb-4">
            <div class="card-body">
              <p class="card-text">Maternal haplogroup</p>
              <h5 class="card-title text-red">{{ sharingStore.motherlineResult.haplogroup }}</h5>
              <p v-if="sharingStore.motherlineResult.subclade" class="card-text mt-4">Maternal haplotype</p>
              <h5 v-if="sharingStore.motherlineResult.subclade" class="card-title text-red">{{
                sharingStore.motherlineResult.subclade }}</h5>
            </div>
          </div>

          <p>Mitochondrial or MT DNA is found in the mitochondria cells. It contains 16,500 DNA bases, meaning it is
            much
            smaller than the autosomal genome (3 billion) or the Y chromosome (50,000). You will see this if you choose
            to
            download your raw data.</p>
          <p>Mitochondrial DNA is passed directly to you by your mother, and to her by her mother and so on without
            undergoing any changes (recombination). This means your MT DNA information is identical to your mother,
            because
            of this we can tell you about your ancestral information from your mother.</p>
          <div class="col-sm-12">
            <MigrationMap v-if="sharingStore.motherlineResult" :result="sharingStore.motherlineResult" type="mtdna" />
          </div>
        </div>
        <div v-else class="card card-maternal mt-5">
          <div class="card-body">
            <p class="card-text">{{ sharingStore.name }} does not have motherline results to share</p>
          </div>
        </div>
      </div>
      <div id="fatherline">
        <div v-if="sharingStore.fatherlineResult">
          <h5 class="pt-3 mb-3">{{ sharingStore.name }}'s Fatherline</h5>
          <div class="card card-maternal border-red mb-4">
            <div class="card-body">
              <p class="card-text">Paternal haplogroup</p>
              <h5 class="card-title text-blue">{{ sharingStore.fatherlineResult.haplogroup }}</h5>
              <p v-if="sharingStore.fatherlineResult.subclade" class="card-text mt-4">Paternal haplotype</p>
              <h5 v-if="sharingStore.fatherlineResult.subclade" class="card-title text-blue">{{
                sharingStore.fatherlineResult.subclade }}</h5>
            </div>
          </div>
          <p>
            The Y chromosome is one of a pair of your sex chromosomes. It is passed from father
            to sons, relatively unchanged which allows us to explore your paternal lineage.
          </p>

          <p>
            By looking at genetic variants we are able to establish patterns of similarity
            between Y Chromosomes. Like a tree as the trunk grows and becomes stronger, it also
            branches off in different directions.
          </p>

          <p>
            This means we are able to provide you with a unique code that is used to describe a
            group of people who all share a common ancestor, known as your paternal haplogroup.
          </p>
          <div class="col-sm-12">
            <MigrationMap v-if="sharingStore.fatherlineResult" :result="sharingStore.fatherlineResult" type="ydna" />
          </div>
        </div>
        <div v-else class="card card-maternal mt-5">
          <div class="card-body">
            <p class="card-text">{{ sharingStore.name }} does not have fatherline results to share</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup>
import { useSharingStore } from "@/store/sharing";
import MigrationMap from "./SharingMigrationMap.vue";
const sharingStore = useSharingStore();
</script>